import { IModel, ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ISectionFilters } from '../../../interfaces/scheduler_interfaces';

export type SelectedSectionFiltersModel = ITypedModel<ISectionFilters>;

angular.module('capability-ng-scheduler').factory(
  'ngSelectedSectionFiltersModel',
  (): SelectedSectionFiltersModel =>
    new Model<ISectionFilters>({
      instructors: [],
      section_labels: []
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_filters/models/selected_section_filters_model.ts